@let signature = (this.mySignature$() | async) ?? null;
<div class="message-box-container flex-column">
  <div class="message-box-header space-between align-center">
    @if (this.collapsed) {
      <cam-link icon="mail" size="sm" [underline]="false" (action)="this.toogleCollapsed()">
        {{ 'communication.message.open-to-reply' | translate }}
      </cam-link>
    }

    <!-- hidden plutôt que @if : détruire la nav lui ferait perdre l'onglet actif -->
    <cam-menu-navigation
      [hidden]="this.collapsed"
      [menu]="this.menu"
      [manuallyChanged$]="this.activateMenuItem$"
      container="tab"
      [options]="{
        spaceElement: 'xs',
      }"
    ></cam-menu-navigation>

    <div class="message-box-actions flex-row align-center g-space-xs">
      <cam-button-tool
        size="sm"
        [icon]="this.openPanel() ? 'arrow-go-back-line' : 'enlarge'"
        (action)="this.toggleExpanded.emit()"
      ></cam-button-tool>
      <cam-button-tool
        size="sm"
        [icon]="this.collapsed ? 'arrow-big-top' : 'arrow-big-bottom'"
        (action)="this.toogleCollapsed()"
      ></cam-button-tool>
    </div>
  </div>

  <div [hidden]="this.collapsed">
    <div
      class="message-container flex-column g-space-sm"
      [class.intern]="this.activeTab === this.CommunicationType.Intern"
    >
      <cam-message-box-input
        [activeTab]="this.activeTab"
        [conversationParticipants]="this.conversationParticipants()"
        [replyTo]="this.replyTo()"
        (correspondents)="this.updateCorrespondents($event)"
      ></cam-message-box-input>

      @if (this.users().length > 0) {
        <cam-cms-editor-input
          [setNewValue$]="this.selectedTemplateVariantBodyChanged$"
          [requestSave$]="this.requestMessage$.asObservable()"
          [clear$]="this.clear$()"
          [maxHeight]="true"
          [users]="this.users()"
          (changed)="this.messageContent.next($event)"
          (saved)="this.send($event, signature)"
        ></cam-cms-editor-input>
      }

      @if (this.replyTo(); as replyToValue) {
        <div class="message-box-section flex-column g-space-xs">
          <div class="space-between align-center">
            @if (replyToValue.isForward) {
              <cam-text size="sm" [isBold]="true">
                {{ 'communication.message.forward-to' | translate }}
              </cam-text>
            } @else {
              <cam-text size="sm" [isBold]="true">
                {{ 'communication.message.replying-to' | translate }}
              </cam-text>
            }
            <cam-font-icon name="close" type="xs" class="c-pointer" (click)="this.replyTo.set(null)"></cam-font-icon>
          </div>

          <cam-expandable-text>
            <cam-response-to-communication
              [responseToCommunicationId]="replyToValue.communication.id"
              [taskId]="this.taskId()"
            ></cam-response-to-communication>
          </cam-expandable-text>
        </div>
      }

      @if (this.withSignature && signature && signature.blocks) {
        <cam-loader [isLoading]="this.requestState.isLoading()">
          <cam-error [code]="this.requestState.getErrorStatus()">
            <div class="message-box-section flex-column g-space-xs">
              <div class="space-between align-center">
                <cam-text size="sm" [isBold]="true">
                  {{ 'communication.message.my-signature' | translate }}
                </cam-text>
                <cam-font-icon
                  name="close"
                  type="xs"
                  class="c-pointer"
                  (click)="this.withSignature = !this.withSignature"
                ></cam-font-icon>
              </div>

              <cam-expandable-text [height]="80">
                <cam-cms-editor-blocks [blocks]="signature.blocks"></cam-cms-editor-blocks>
              </cam-expandable-text>
            </div>
          </cam-error>
        </cam-loader>
      }

      <cam-message-box-attachments
        [attachments]="this.attachments()"
        (remove)="this.removeAttachment($event)"
      ></cam-message-box-attachments>

      <div class="message-box-footer space-between align-center g-space-sm">
        <cam-message-box-toolbar
          [attachments]="this.attachmentsConfig()"
          [hasSignature]="!!(signature && signature.blocks)"
          [message]="this.messageContent | async"
          [responseToCommunicationId]="this.replyTo()?.communication?.id"
          [taskId]="this.taskId()"
          (attachmentsChanged)="this.updateAttachments($event)"
          (changedType)="this.activateMenuItem$.next($event)"
          (generatedMessage)="this.selectedTemplateVariantBodyChanged$.next($event)"
          (toggleAttachments)="this.openAttachments$.next()"
          (toggleSignature)="this.withSignature = !this.withSignature"
          (toggleTemplateChoice)="this.toggleTemplateChoice()"
        ></cam-message-box-toolbar>

        <div class="message-box-send flex-row align-center g-space-sm">
          @if (this.activeTab === this.CommunicationType.Intern) {
            <cam-text size="sm">
              {{ 'communication.message.internal' | translate }}
            </cam-text>
          }
          @if (this.activeTab !== this.CommunicationType.Intern && this.statusTemplate(); as statusTemplate) {
            <ng-template [ngTemplateOutlet]="statusTemplate"></ng-template>
          }
          <cam-button size="sm" (action)="this.requestMessage$.next()">
            {{ 'communication.message.cta' | translate }}
          </cam-button>
        </div>
      </div>
    </div>
  </div>
</div>

<cam-layout-full-panel
  [toggleState]="this.templateChoiceModal.open()"
  (closeEvent)="this.templateChoiceModal.open.set(false)"
  title="communication.templates.choice.title"
  type="modal"
  size="lg"
>
  @if (this.templateChoiceModal.open()) {
    <cam-communication-template-choice
      [type]="this.activeTab"
      (selected)="this.selectTemplateVariant($event); this.templateChoiceModal.open.set(false)"
    ></cam-communication-template-choice>
  }
</cam-layout-full-panel>
